import { Card, Row, Dropdown, Button } from "antd";
import "./RequestItemDetails.css";
import Loader from "../loaders/Loader";
import { DownOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RequestItemDetailsFooter from "./RequestItemDetailsFooter";
import { ArrowLeftOutlined } from "@ant-design/icons";

const RequestItemDetails = () => {
  const { requestsStore, userStore } = useMobxStores();

  const params = useParams();
  const navigate = useNavigate();

  const isRequestListingOwner =
    requestsStore.requestListing?.poster_username === userStore.user?.username;

  const isRequestListingCurrent =
    Number(params.requestId) === Number(requestsStore.currentRequestId);

  useEffect(() => {
    const fetchListing = async () => {
      requestsStore.GetRequestListingById(params.requestId);
    };

    fetchListing();
  }, [params]);

  const statusMenu = {
    items: [
      {
        key: "inProcess",
        label: "In process",
        onClick: () =>
          requestsStore.PatchRequestListing(requestsStore.requestListing.id, {
            title: requestsStore.requestListing.title,
            description: requestsStore.requestListing.description,
            email: requestsStore.requestListing.email,
            status: "In process",
            type: requestsStore.requestListing.type,
          }),
      },
      {
        key: "completed",
        label: "Completed",
        onClick: () =>
          requestsStore.PatchRequestListing(requestsStore.requestListing.id, {
            title: requestsStore.requestListing.title,
            description: requestsStore.requestListing.description,
            email: requestsStore.requestListing.email,
            status: "Completed",
            type: requestsStore.requestListing.type,
          }),
      },
    ],
    className: "status-menu",
  };

  if (!isRequestListingCurrent || requestsStore.loading) {
    return <Loader />;
  }

  return (
    <div className="request-details-page">
      <Button
        icon={<ArrowLeftOutlined />}
        size="large"
        onClick={() => navigate(-1)}
        className="request-back-simple-button"
      />
      <Card className="request-details-card">
        <div className="request-details-card-content">
          <div style={{ marginBottom: "16px" }}>
            <Row justify={"space-between"} style={{ alignItems: "end" }}>
              <div className="request-details-title">
                {requestsStore.requestListing?.title}
              </div>
              <div className="request-details-date">
                {new Date(
                  requestsStore.requestListing?.timestamp
                ).toLocaleString()}
              </div>
            </Row>
            <Row style={{ gap: "12px", marginTop: "16px" }}>
              <div className="posted-by-text">Posted by</div>
              <div className="posted-by-username">
                {requestsStore.requestListing?.poster_username}
              </div>
            </Row>
            <div className="request-details-description">
              {requestsStore.requestListing?.description}
            </div>
            <div className="type-status-container">
              <Row>
                <div
                  className="request-details-text"
                  style={{ marginBottom: "16px" }}
                >
                  Type
                </div>
                <div className="request-details-type">
                  {requestsStore.requestListing?.type}
                </div>
              </Row>
              <Row>
                <div
                  className="request-details-text"
                  style={{ marginBottom: "16px" }}
                >
                  Status
                </div>
                {isRequestListingOwner ? (
                  <Dropdown menu={statusMenu} trigger={["hover"]}>
                    <div
                      className="request-details-status"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: "8px",
                        justifyContent: "center",
                      }}
                    >
                      {requestsStore.requestListing?.status}
                      <DownOutlined style={{ fontSize: "16px" }} />
                    </div>
                  </Dropdown>
                ) : (
                  <div
                    className="request-details-status"
                    style={{
                      cursor: isRequestListingOwner && "pointer",
                      display: "flex",
                      gap: "4px",
                      justifyContent: "center",
                    }}
                  >
                    {requestsStore.requestListing?.status}
                  </div>
                )}
              </Row>
            </div>
          </div>
          <div>
            <RequestItemDetailsFooter
              requestId={params.requestId}
              isRequestListingOwner={isRequestListingOwner}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default observer(RequestItemDetails);
